import { useMutation } from '@tanstack/react-query'
import { updatePassword } from 'services/me'

export function useUpdatePassword() {
  return useMutation(updatePassword)
}
